module.exports = __webpack_public_path__ + "static/naslovna-slike-81080717b8f4516607e7ad9d9b843649.png";